module.exports = __webpack_public_path__ + "static/media/total.7f99c5ac.svg";